export const findAppointmentStatus = ({ status, type }) => {
  if (type === "PICKUP") {
    return status === "STARTED"
      ? "PICKED_UP"
      : status === "FINISHED"
      ? "DELIVERED"
      : status;
  } else return status;
};
